import React, { useContext } from 'react';
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  text-align: center;
  margin: 130px 0;
  h1 {
    font: bold italic 36px 'Times new roman';
  }
`

const NotFound = () => {
  const { language } = useContext(LanguageContext);
  let title = ''
  let h1 = ''
  let text = ''
  switch (language) {
    case 'pt-br':
      title = 'Guararapes - Página não encontrada';
      h1 = 'Página não encontrada';
      text = 'Esse link nunca existiu ou não existe mais :(';
      break;
    case 'en-us':
      title = 'Guararapes - Page not found';
      h1 = 'Page not found';
      text = 'This page has never existed or doesn\'t exist anymore :(';
      break;
    case 'es-es':
      title = 'Guararapes - Página no encontrada';
      h1 = 'Página no encontrada';
      text = 'Esta página nunca existió o ya no existe :(';
      break;
    default:
  }
  return (
    <div id="home">
      <MetaTags>
        <title>{ title }</title>
      </MetaTags>
      <Header />
      <Container>
        <div className="wrapper">
          <h1>{ h1 }</h1>
          <p>
            { text }
          </p>
        </div>
      </Container>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default NotFound;
